function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-V2-Popout",
  transform: "translate(-747.000000, -622.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-44",
  transform: "translate(727.500000, 432.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-39"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(20.133500, 190.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.9465868,5.99546108 C10.9566467,5.44300599 10.5299401,4.9917485 9.98598802,4.97977246 C9.44491018,4.96779641 8.99497006,5.40839521 8.98694611,5.95809581 C8.97856287,6.51594012 9.39988024,6.95905389 9.94850299,6.96971257 C10.497006,6.98037126 10.9364072,6.55138922 10.9465868,5.99546108 M10.7045509,11.9443234 C10.7045509,11.0665988 10.7056287,10.1888743 10.7041916,9.3111497 C10.7033533,8.81474251 10.4736527,8.49354491 9.95916168,8.49804807 C9.44239521,8.50264671 9.22934132,8.83342515 9.2297006,9.32695808 C9.23077844,11.0824072 9.23281437,12.837976 9.22801801,14.5934251 C9.22670659,15.0897126 9.4445509,15.4031257 9.94562874,15.4498323 C10.3912575,15.4913892 10.6958084,15.1348623 10.702515,14.577497 C10.7130539,13.6998922 10.7052695,12.8220479 10.7045509,11.9443234 M9.99700599,-3.81322094e-05 C15.5168862,0.017257485 19.951018,4.47809581 19.9346562,9.99749701 C19.9180838,15.5152216 15.4524551,19.9551018 9.93736527,19.936835 C4.41976048,19.9185749 -0.0158083832,15.4555808 7.69961463e-05,9.93785629 C0.0159281437,4.41917365 4.47868263,-0.0172335329 9.99700599,-3.81322094e-05",
  id: "Fill-1",
  fill: "#746B7A"
}))))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.bc1481d6.svg";
export { ForwardRef as ReactComponent };